import React from 'react';
import { PRIMARY } from '../../../../theme';
export var TriangleDown = function TriangleDown(props) {
  var triangleFill = props.color || PRIMARY;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 7 3",
    height: "100%",
    width: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96135 2.93603L0.98812 0.278897L6.93457 0.278898L3.96135 2.93603Z",
    fill: triangleFill
  }));
};